import React , {useState} from 'react';
import {getCredit, getCreditFromFarhangi} from "../../Actions";
import {connect} from 'trim-redux';
import {toNum, ToRialComma} from "../../utils";
import Num2persian from 'num2persian';
import $ from 'jquery';
const Farhangi = ({paymenttoken , customerAccessToken , buttonDisabled , buttonLoading,minCreditError }) => {
    const [checkes , setCheckbox] = useState(
        [
            {id: 1, value: "کپی کارت ملی", isChecked: false},
            {id: 2, value: "کپی فیش حقوقی", isChecked: false},
            {id: 3, value: "حکم کارگزینی", isChecked: false},
        ]
    );
    const [persian , setPersian] = useState('');
    const [bankAcc , setBank] = useState('');
    const [income , setIncome] = useState('');
    const [err , setErr] = useState(false);
    function handleCheck(e) {
        checkes.forEach(c => {
            if (c.value === e.target.value)
                c.isChecked = e.target.checked
        });
        setCheckbox(checkes);
    }
    function handlebankAcc(e) {
        setBank(toNum(e.target.value))
    }
    function handleIncome(e) {
        setIncome(toNum(e.target.value))
    }
    function callGetCredit() {
        if(bankAcc.length < 11)
            setErr(true);
        else {
            let correctBankAcc = "0000000000000".concat(bankAcc).slice(-13);
            getCreditFromFarhangi(paymenttoken, income, correctBankAcc, localStorage.customerAccessToken)
        }
        }
    $('.rial').on('keyup',function(){
        $(this).val(ToRialComma($(this).val()));
        let f = Num2persian(Math.round(toNum($(this).val())/10));
        setPersian(f + ' تومان')
    });
    $('.rial').on('focusout',function(){
        $(this).val(ToRialComma($(this).val())+" ریال " );
    });
    $('.rial').on('focusin',function(){
    
        setPersian('')
    });
    $('.bank-acc').on('focusout' , function () {
       
       if(   this.value.length < 11 )
           setErr(true)
       else{
           setErr(false)
           $(this).val("0000000000000".concat(this.value).slice(-13))
       }
       
    });
    $('.bank-acc').on('focusin' , function () {
        $(this).val("");
    });
    return (
        <div>
                <div className='installment-info reception-info farhangi' style={{marginTop: 25}}>
                     <span className='recieve-docs'>:لطفا دریافت مدارک زیر را تایید کنید</span>
                    <div className='farhangi-inputs-wrapper'>
                        {
                            checkes.map((c) =>
                                <label className='checkbox-group'>
                                    {c.value}
                            <input type='checkbox' id={c.id} value={c.value} onChange={handleCheck} checked className='doc-checkbox'/>
                           <span className='checkmark'></span>
                            </label>
                            )
                        }
                    </div>
                </div>
            <div className='installment-info vertical-layout' style={{width: '74%', marginTop: 23}}>
                <section style={{marginRight: 2}}>
                    <span className='info-titles inputs-label farhangi-input-label'>خالص دریافتی</span>
                </section>
                <section>
                    <div className='input-group farhangi-inputs'>
                        <input type='text' placeholder='ورود مبلغ' onChange={handleIncome}  className='rial form-control' style={{direction: 'rtl'  , textAlign: 'left' , padding: 12}}/>
                    </div>
                    <p style={{textAlign: 'center' , color: '#093b7c' , fontFamily: "Shabnam" , fontSize: 12 , fontWeight: 600 , lineHeight: 2.08}}>{persian} </p>
                </section>
            </div>
            <div className='installment-info vertical-layout' style={{width: '74%' , marginTop: 25}}>
                <section style={{marginRight: 2}}>
                    <span className='info-titles inputs-label farhangi-input-label'>شماره حساب</span>
                </section>
                <section>
                    <div className='inputs-wrapper farhangi-inputs'>
                        <input type='text' onChange={handlebankAcc} placeholder='شماره حساب بدون خط تیره'
                               className={err ? 'form-control bank-acc errorBorder' : 'form-control bank-acc'}
                               style={{direction: 'rtl'  , textAlign: 'left' , padding: 12}} maxLength={13} minLength={11}/>
                        <span className={err ? "errorMsg display-block" : 'display-none'} style={{textAlign: 'right'    }}>شماره حساب وارد شده نادرست است</span>
                    </div>
                </section>
                <div className={minCreditError ? "userNotFound display-block" : "display-none"}>
                    <p>موجودی اعتبار شما برای خرید از این فروشگاه کافی نیست</p>
                    <ul>
                        <li>
                            در صورت هرگونه سوال، با پشتیبانی کیپا تماس حاصل فرمائید.
                        </li>
                    </ul>
                </div>
            </div>
            <div className='installment-info reception-info vertical-layout'>
                <section>
                    <div className='input-group farhangi-inputs'>
                        <button className="big-success-btn" disabled={buttonDisabled} style={{height: 48 , marginBottom: 35}} onClick={callGetCredit}>
                            {
                                buttonLoading ? (
                                    <div className="spinner" style={{margin:  "auto"}}>
                                        <div className="bounce1" style={{width: 6 , height: 6 , margin: "0 1px" , background: "#fff"}}></div>
                                        <div className="bounce2" style={{width: 6 , height: 6 , margin: "0 1px" , background: "#fff"}}></div>
                                        <div className="bounce3" style={{width: 6 , height: 6 , margin: "0 1px" , background: "#fff"}}></div>
                                    </div>) : "تایید و ادامه"
                            }

                        </button>
                    </div>
                </section>
            </div>
            <div className='installment-info reception-info vertical-layout'>
                <section>
                    {/*<div className='input-group farhangi-inputs'>*/}
                        {/*<button className="big-cancel-btn" style={{height: 48 , marginBottom: 40}}>*/}
                            {/*انصراف*/}
                        {/*</button>*/}
                    {/*</div>*/}
                </section>
            </div>
        </div>
    )
};
const mstp = state => ({
    paymenttoken: state.paymentToken,
    customerAccessToken: state.customerAccessToken,
    buttonLoading: state.buttonLoading,
    buttonDisabled: state.buttonDisabled,
    minCreditError: state.minCreditError
});

export default connect (mstp)(Farhangi);